// export const phoneRegex = /^\+234\d{10}$/; // Regex pattern for Nigerian phone numbers starting with "+234"
export const phoneRegex = /^\d{11}$/; // Regex pattern for Nigerian phone numbers starting with "+234"
// export const phoneRegex = /^(\+?234|0)?[789]\d{10}$/; // Regex pattern for Nigerian phone numbers +234 or 080

export const formatNaira = (val: number) =>
  val.toLocaleString('en-NG', {
    style: 'currency',
    currency: 'NGN',
    // minimumFractionDigits: 0,
    // maximumFractionDigits: 0,
  });

export const formateDatimeStrToNiajaTime = (dateTimeString: string) => {
  const date = new Date(dateTimeString);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: 'Africa/Lagos',
  } as Intl.DateTimeFormatOptions;

  return date.toLocaleString('en-NG', options);
};

export function capitalize(str: string) {
  if (typeof str !== 'string' || str.length === 0) {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}


export function formatForStatus(input: string) {
  return input
    .trim() // Remove leading and trailing whitespace
    .toLowerCase() // Convert the entire string to lowercase
    .split(/[\s_]+/) // Split the string into an array of words
    .filter(word => word) // Remove any empty elements (in case of multiple spaces)
    .join('-'); // Join the words with hyphens
}


export function formatBadge(str: string): string {
  // Convert the string to lowercase
  let formattedStr = str.toLowerCase();

  // Replace underscores and hyphens with spaces
  formattedStr = formattedStr.replace(/[_-]/g, ' ');

  // Capitalize the first letter of each word
  formattedStr = formattedStr.replace(/\b\w/g, (char) => char.toUpperCase());

  return formattedStr;
}


export function processListOfStrings(stringList: string[]): string[] {
  return stringList.map((str) => {
    // Convert the string to lowercase
    let formattedStr = str.toLowerCase();

    // Replace underscores and hyphens with spaces
    formattedStr = formattedStr.replace(/[_-]/g, ' ');

    // Capitalize the first letter of each word
    formattedStr = formattedStr.replace(/\b\w/g, (char) => char.toUpperCase());

    return formattedStr;
  });
}

export const createObjectFromLists = (keys: string[], values: string[]): Record<string, string> => {
  return keys.reduce((acc, key, index) => {
    acc[key] = values[index];
    return acc;
  }, {} as Record<string, string>);
};

